import { createFileRoute } from '@tanstack/react-router';

import { loadSpiConsultScreen, loadSpiMessages, spiConsultScreen, spiConsultSearch } from '@/modules/spi/route';
import { lazyScreen } from '@/shared/screen';

// Consulta de operações PIX no caminho do legado (`router.tsx:678-682`), aninhada na Gestão SPI.
export const Route = createFileRoute('/_app/contas-digitais/gestao-spi/consultas/')({
  validateSearch: spiConsultSearch,
  staticData: { screen: spiConsultScreen },
  loader: () => loadSpiMessages(),
  component: lazyScreen(loadSpiConsultScreen, 'SpiConsultRouteScreen'),
});
